export interface InsidePage {
  src: string
  alt: string
}

/** The five real interior pages of the product — do not replace with mockups. */
export const insidePages: InsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/dn1GGWXZiii9wFSC47g17e/Captura_de_pantalla_2026-10-16_a_la(s)_1.13.18_p._m..png',
    alt: 'Interior page: The Six-Pack Integrated — interpreting multiple flight instruments together',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/seH9U9SJ8AAMiQaszdevcV/Captura_de_pantalla_2026-10-16_a_la(s)_1.13.02_p._m..png',
    alt: 'Interior page: Attitude & Flight Path — why aircraft attitude is not aircraft performance',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qdaa8B6izeHMhFKXeFwmNy/Captura_de_pantalla_2026-10-16_a_la(s)_1.12.41_p._m..png',
    alt: 'Interior page: Altimeter Pressure Settings — barometric reference and indicated altitude',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/spG7mY4wuufgwtzuGzjMzC/Captura_de_pantalla_2026-10-16_a_la(s)_1.12.15_p._m..png',
    alt: 'Interior page: The Traditional Six-Pack — identifying the six primary flight instruments',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/p1KahdD1MchrvvidWFuQfz/Captura_de_pantalla_2026-10-16_a_la(s)_1.12.02_p._m..png',
    alt: 'Interior page: The General Aviation Cockpit — the cockpit as an integrated information system',
  },
]
